export default __webpack_public_path__ + "static/media/paper.87307632.svg";